export function TrustStats() {
  return (
    <section className="relative py-14 px-6 lg:px-8 border-y border-line bg-sg">
      {/* Visual connector line */}
      <div className="sc" aria-hidden="true">
        <svg width="2" height="24" viewBox="0 0 2 24">
          <line x1="1" y1="0" x2="1" y2="24" className="sc-line" stroke="#2563EB" strokeOpacity="0.3" strokeWidth="1.5" />
        </svg>
        <span className="sc-node" />
      </div>

      <div className="max-w-7xl mx-auto">
        <p className="text-center text-[13px] text-muted mb-10 max-w-lg mx-auto leading-relaxed">
          Designed for the 47,000+ organisations India's DPDP Act classifies as data fiduciaries. Built for the ones that treat compliance as infrastructure, not administration.
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-5 gap-px bg-line rounded-xl2 overflow-hidden border border-line">
          <div className="bg-card px-6 py-5 text-center">
            <div className="mono text-[22px] font-bold text-ink">42ms</div>
            <div className="text-[11.5px] text-muted mt-1">API p50 latency</div>
          </div>
          <div className="bg-card px-6 py-5 text-center">
            <div className="mono text-[22px] font-bold text-ink">99.98%</div>
            <div className="text-[11.5px] text-muted mt-1">Uptime SLA</div>
          </div>
          <div className="bg-card px-6 py-5 text-center">
            <div className="mono text-[22px] font-bold text-ink">4</div>
            <div className="text-[11.5px] text-muted mt-1">Official SDKs</div>
          </div>
          <div className="bg-card px-6 py-5 text-center">
            <div className="mono text-[22px] font-bold text-ink">3</div>
            <div className="text-[11.5px] text-muted mt-1">India regions</div>
          </div>
          <div className="bg-card px-6 py-5 text-center col-span-2 sm:col-span-1">
            <div className="mono text-[22px] font-bold text-ink">v1.4.2</div>
            <div className="text-[11.5px] text-muted mt-1">SDK · Generally Available</div>
          </div>
        </div>
      </div>
    </section>
  );
}
